<template>
  <header>
      <v-app-bar
        color="#6A76AB"
        dark
        shrink-on-scroll
        prominent
        src="https://picsum.photos/1920/1080?random"
        fade-img-on-scroll
        scroll-target="#scrolling-techniques-4"
      >
        <template v-slot:img="{ props }">
          <v-img
            v-bind="props"
            gradient="to top right, rgba(19,84,122,.5), rgba(128,208,199,.8)"
          ></v-img>
        </template>

        <v-toolbar-title>写真あげMASKぁ～？？</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn @click="twitterShare" color="#00acee"><i class="fab fa-twitter"></i><v-text>Tweet</v-text></v-btn>

        <template v-slot:extension>
            <v-tabs align-with-title>
              <v-tab router-link to="/" id="nav">Home</v-tab>
              <v-tab router-link to="/upload" id="nav">MASK</v-tab>
              <v-tab router-link to="/en" id="nav">Home(English)</v-tab>
              <v-tab router-link to="/en/upload" id="nav">MASK(English)</v-tab>
            </v-tabs>
          </template>
      </v-app-bar>
  </header>
</template>

<script>
  import constants from '../common/constants.js'
  export default {
    name: 'AppHeader',
    data () {
      return {
        drawer: false,
        menuItems: constants.menuItems
      }
    },
    methods:{
      twitterShare(){
      //シェアする画面を設定
      var shareURL = 'https://twitter.com/intent/tweet?text=' + "写真あげMASKぁ〜？？で作成されました。https://icy-moss-046b41900.azurestaticapps.net/" + "%20%23Cos5year";  
      //シェア用の画面へ移行
      location.href = shareURL
    }
    }
  }
</script>

<style>
  #nav {
    padding: 30px;
  }
  #nav a {
    font-weight: bold;
    color: #2c3e50;
  }
  #nav a.router-link-exact-active {
    color: #42b983;
  }
</style>